module.exports = __webpack_public_path__ + "static/media/premission-tip-2.9475d7d1.jpg";